import moment from 'moment';

import { ISeason } from '../../../../store/seasons/store';

import { today } from '../../../../Utils/today';
import { dateFormat } from '../../../../contrib/utils';

export const getCurrentSeason = (seasons: ISeason[]) => {
  const foundSeason = seasons.find(season => {
    const seasonStartDate = moment(season.start, dateFormat);
    const seasonEndDate = moment(season.end, dateFormat);

    return today.isBetween(seasonStartDate, seasonEndDate);
  });

  return foundSeason || seasons[0];
};
